import { useAppDispatch } from '../../base';
import { toolsActions } from '../../actions';
import ActiveChat from '../../components/ToolsComponents/ActiveChat';
import { useEffectOnce } from 'react-use';

const ToolsCreateJobPage = () => {
    const dispatch = useAppDispatch();

    useEffectOnce(() => {
        dispatch(toolsActions.fetchActiveChatQuestions());
    });

    return <ActiveChat />;
};

export default ToolsCreateJobPage;
